import { useState, useRef, useEffect } from "react";

export const TooltipMouseTrack = ({
  message,
  duration = 2000, // in milliseconds
  offsetX = 0, //integer (in pixels)
  offsetY = 0, //integer (in pixels)
  children,
  hideEvent, //simply update this value to manually hide the tooltip
  doOnce,
  cooldown = 0, //wait this long in milliseconds since the last time the tooltip was triggered to be able to trigger it again.
  containerClass,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [tooltipOpacity, setTooltipOpacity] = useState(1);
  const [displayedCount, setDisplayedCount] = useState(0);
  const [cooldownOver, setCooldownOver] = useState(true);
  // const [rotation, setRotation] = useState(0);

  const handleTooltipMouseMove = (e) => {
    // console.log(e.nativeEvent.clientX);
    // console.log(e.nativeEvent.clientY);
    e.stopPropagation();
    e.preventDefault();
    setTooltipPosition({
      x: e.nativeEvent.clientX + 20,
      y: e.nativeEvent.clientY,
    });
  };

  useEffect(() => {
    setShowTooltip(false);
  }, [hideEvent]);

  const tooltipTimer = useRef();
  const handleMouseEnterTooltip = () => {
    if (!cooldownOver) {
      return;
    }
    if (doOnce && displayedCount > 0) {
      return;
    }
    setCooldownOver(false);
    setTimeout(() => {
      setCooldownOver(true);
    }, cooldown);
    setDisplayedCount((prev) => prev + 1);
    setShowTooltip(true);
    setTooltipOpacity(1);
    // setRotation(0);
    tooltipTimer.current = setTimeout(() => {
      // setShowTooltip(false);
      setTooltipOpacity(0);
      // setRotation(3600);
    }, duration);
  };
  const handleMouseLeaveTooltip = () => {
    setShowTooltip(false);
    clearTimeout(tooltipTimer.current);
  };

  return (
    <>
      <div
        onMouseEnter={handleMouseEnterTooltip}
        onMouseLeave={handleMouseLeaveTooltip}
        onMouseMove={handleTooltipMouseMove}
        className={containerClass}
      >
        {children}
      </div>
      {showTooltip && (
        <div
          className="z-index-30000"
          style={{
            // border: "1px solid black",
            borderRadius: "3px",
            position: "fixed",
            // top: tooltipPosition.y,
            // left: tooltipPosition.x,
            top: 0,
            left: 0,
            transform: `translate(${tooltipPosition.x + offsetX}px, ${
              tooltipPosition.y + offsetY
            }px)`,
            padding: "5px",
            backgroundColor: "rgba(70,70,70, .8)",
            color: "white",
            fontSize: ".8em",
            transition: "opacity .5s, rotate .5s",
            opacity: tooltipOpacity,
          }}
          id="tracking-tooltip"
        >
          {message}
        </div>
      )}
    </>
  );
};
